module.exports = __webpack_public_path__ + "img/Shakti Top Finance.75b999b8.png";